<item-thumbnail matRipple [item]="item" (click)="viewListing()" style="cursor: pointer;"/>
<div>
  <a *ngIf="showPrice" [routerLink]="['/view-listing/', item.id]">
    <b>{{item.price!.toNumber() | currency : item.price!.currency()}}</b>
  </a>
</div>
<div class="mat-small title">
  <a [routerLink]="['/view-listing/', item.id]">{{item.title}}</a>
</div>